import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08b62715"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-page" }
const _hoisted_2 = { class: "game-page__wrapper" }
const _hoisted_3 = {
  ref: "canvas",
  width: "600",
  height: "600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_status_bar = _resolveComponent("status-bar")!
  const _component_settings = _resolveComponent("settings")!
  const _component_touch_control = _resolveComponent("touch-control")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_status_bar, {
      scores: _ctx.scores,
      "is-playing": _ctx.isPlaying,
      "is-paused": _ctx.isPaused,
      onPaused: _ctx.pause
    }, null, 8, ["scores", "is-playing", "is-paused", "onPaused"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("canvas", _hoisted_3, null, 512),
      (!_ctx.isPlaying || _ctx.isPaused)
        ? (_openBlock(), _createBlock(_component_settings, {
            key: 0,
            levels: _ctx.levels,
            "is-playing": _ctx.isPlaying,
            "is-paused": _ctx.isPaused,
            onStarted: _ctx.start,
            onResumed: _ctx.resume
          }, null, 8, ["levels", "is-playing", "is-paused", "onStarted", "onResumed"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_touch_control)
  ]))
}